import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.invoiceFrequenciesList,"item-value":"id","item-text":"name","label":"Invoice Frequency","rules":[_vm.requiredCheck()],"disabled":_vm.disabled,"clearable":_vm.clearable ? _vm.clearable : false,"readonly":_vm.readOnly ? _vm.readOnly : false,"outlined":""},model:{value:(_vm.idValue),callback:function ($$v) {_vm.idValue=$$v},expression:"idValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }